"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkDocument = checkDocument;
exports.getDefaultValues = getDefaultValues;
exports.getFragmentDefinition = getFragmentDefinition;
exports.getFragmentDefinitions = getFragmentDefinitions;
exports.getMainDefinition = getMainDefinition;
exports.getOperationDefinition = getOperationDefinition;
exports.getOperationName = getOperationName;
exports.getQueryDefinition = getQueryDefinition;
var _index = require("apollo-stack-hubspot/@apollo/client/utilities/globals/index");
var _storeUtils = require("apollo-stack-hubspot/@apollo/client/utilities/graphql/storeUtils");
// Checks the document for errors and throws an exception if there is an error.
function checkDocument(doc) {
  (0, _index.invariant)(doc && doc.kind === "Document", 76);
  var operations = doc.definitions.filter(function (d) {
    return d.kind !== "FragmentDefinition";
  }).map(function (definition) {
    if (definition.kind !== "OperationDefinition") {
      throw (0, _index.newInvariantError)(77, definition.kind);
    }
    return definition;
  });
  (0, _index.invariant)(operations.length <= 1, 78, operations.length);
  return doc;
}
function getOperationDefinition(doc) {
  checkDocument(doc);
  return doc.definitions.filter(function (definition) {
    return definition.kind === "OperationDefinition";
  })[0];
}
function getOperationName(doc) {
  return doc.definitions.filter(function (definition) {
    return definition.kind === "OperationDefinition" && !!definition.name;
  }).map(function (x) {
    return x.name.value;
  })[0] || null;
}
// Returns the FragmentDefinitions from a particular document as an array
function getFragmentDefinitions(doc) {
  return doc.definitions.filter(function (definition) {
    return definition.kind === "FragmentDefinition";
  });
}
function getQueryDefinition(doc) {
  var queryDef = getOperationDefinition(doc);
  (0, _index.invariant)(queryDef && queryDef.operation === "query", 79);
  return queryDef;
}
function getFragmentDefinition(doc) {
  (0, _index.invariant)(doc.kind === "Document", 80);
  (0, _index.invariant)(doc.definitions.length <= 1, 81);
  var fragmentDef = doc.definitions[0];
  (0, _index.invariant)(fragmentDef.kind === "FragmentDefinition", 82);
  return fragmentDef;
}
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */
function getMainDefinition(queryDoc) {
  checkDocument(queryDoc);
  var fragmentDefinition;
  for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
    var definition = _a[_i];
    if (definition.kind === "OperationDefinition") {
      var operation = definition.operation;
      if (operation === "query" || operation === "mutation" || operation === "subscription") {
        return definition;
      }
    }
    if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
      // we do this because we want to allow multiple fragment definitions
      // to precede an operation definition.
      fragmentDefinition = definition;
    }
  }
  if (fragmentDefinition) {
    return fragmentDefinition;
  }
  throw (0, _index.newInvariantError)(83);
}
function getDefaultValues(definition) {
  var defaultValues = Object.create(null);
  var defs = definition && definition.variableDefinitions;
  if (defs && defs.length) {
    defs.forEach(function (def) {
      if (def.defaultValue) {
        (0, _storeUtils.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
      }
    });
  }
  return defaultValues;
}